import { _AdvertiseImgAssembledBase as AdvertiseImgAssembledBase } from './cssVar/advertiseImgAssembledBase'
import { _AdvertiseImgAssembledDefault as AdvertiseImgAssembledDefault } from './cssVar/advertiseImgAssembledDefault'
import { _AdvertiseImgAssembledSmall as AdvertiseImgAssembledSmall } from './cssVar/advertiseImgAssembledSmall'
import { Base, Component, Inject, Mixins } from '@/vue-property-decorator'
import { CardDefaultBgImg } from '../class/cardDefaultBgImg'
import { GameCategoryIds } from '@/views/game/consts/categorys'
import { GetCssVarManager } from '@/views/game/components/gameCardSuit/components/baseCssVarProvide'
import { LandscapeProps } from '../../components/basePropsConfig'
import { nodeThemeConfig } from '@/context/const'
import { useMainStore } from '@/store/index'
import BaseCssVarInject from '../../../../components/baseCssVarInject'
import Copywriting, { CopywritingBase } from './copywriting'
import HallCustomization from '@/controller/hallCustomization'
import style from './style.module.scss'
export type AdvertiseImgAssembledCssVarManager =
  GetCssVarManager<AdvertiseImgAssembledBase>
export {
  AdvertiseImgAssembledBase,
  AdvertiseImgAssembledDefault,
  AdvertiseImgAssembledSmall
}
/** 完整独立的一张广告图片 */
@Component<AdvertiseImgAssembled>({
  name: 'AdvertiseImgAssembled'
})
export default class AdvertiseImgAssembled extends Mixins<
  Base<unknown, unknown, unknown>,
  BaseCssVarInject<AdvertiseImgAssembledBase, { copywriting?: CopywritingBase }>
>(Base, BaseCssVarInject) {
  /** 获得默认样式cssVar */
  public static getCssVarDefault = () => new AdvertiseImgAssembledDefault()
  /** 获得小号样式cssVar */
  public static getCssVarSmall = () => new AdvertiseImgAssembledSmall()

  @Inject('cardProps') cardProps!: Required<LandscapeProps>

  render() {
    const { isJackpot, imgUrl, bgImg, categoryId, gameName, logoUrl } =
      this.cardProps
    const { siteInfos } = useMainStore()
    return (
      <my-img
        class={{
          [style['advertse-img-assembled']]: true,
          [style[`type-${this.finialCssType}`]]: Boolean(this.finialCssType)
        }}
        options={{ type: 'div' }}
        src={
          HallCustomization.gameListBg ||
          bgImg ||
          CardDefaultBgImg.getBgImg(
            categoryId as GameCategoryIds,
            siteInfos?.backgroundColor === nodeThemeConfig.ThemeSkinBg.HAS_BG
          )
        }
      >
        {/* 主体左边,内容是文案部分 */}
        <div class={style['introduce-left']}>
          <Copywriting
            gameName={gameName}
            isJackpot={isJackpot}
            logoUrl={logoUrl}
          />
        </div>
        {/* 主体右边,广告图位置 */}
        <div class={style['introduce-right']}>
          <my-img
            class={style['advertisement-image']}
            src={imgUrl}
            options={{ type: 'div' }}
          />
        </div>
      </my-img>
    )
  }
}
